import React from "react";
import "../styles/Stats.css";
import { useLanguage } from "../contexts/LanguageContext";

const Stats = () => {
  const { language, text } = useLanguage();
  const isHeb = language === "he";

  return (
    <section id="stats" className="stats-section" dir={isHeb ? "rtl" : "ltr"}>
      <div className="stats-row">
        {text.stats.items.map((s) => (
          <div key={s.label} className="stat-card">
            <div className="stat-value gradient-text">{s.value}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
